module.exports = __webpack_public_path__ + "img/archi3Shadow@2x.29077834.png";